import * as React from "react";

import { isNotNullOrUndefined } from "../../../Common/TypingUtils";
import {
    AbsoluteModelPath,
    AbsoluteResolvedModelPath,
    convertToAbsoluteModelPath,
} from "../../../Common/ModelPath/ModelPath";

import { createHocDisplayName } from "./TypingUtils";

export interface UnresolvedControlDependency {
    path: AbsoluteModelPath;
    propName?: string;
    valueName?: string;
    field?: string;
    value?: string;
}

export interface ControlDependency {
    path: AbsoluteResolvedModelPath;
    propName?: string;
    valueName?: string;
}

interface WithDeps {
    dependencies?: UnresolvedControlDependency[];
}

/**
 * Добавляет к компоненту массив dependencies, вычисляемый по children-ам во время выполнения
 */
export function withRuntimeDependencies<P>(Comp: React.ComponentType<P & WithDeps>): React.ComponentType<P> {
    return class RuntimeDependenciesContainer extends React.Component<P> {
        public static displayName = createHocDisplayName(Comp, "RuntimeDeps");

        public render(): JSX.Element {
            return <Comp {...this.props} dependencies={this.resolveDependencies()} />;
        }

        private resolveDependencies(): Array<{ path: AbsoluteModelPath }> {
            return React.Children.map(this.props.children ?? [], child => {
                if (!React.isValidElement<{ bindingPath: AbsoluteModelPath }>(child)) {
                    return undefined;
                }
                if (child.props.bindingPath === undefined) {
                    return undefined;
                }
                return { path: convertToAbsoluteModelPath(child.props.bindingPath) };
            }).filter(isNotNullOrUndefined);
        }
    };
}
